






















import { listFactory } from '@/main/pages';
import { getColumnsNames } from '@/main/utils/table';
import { getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			parameters: 'null' as string,
			selectedWorkshops: [] as number[],
		};
	},
	methods: {
		async filterClick() {
			if (this.WorkshopId == null) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
				return;
			}
			if (this.WareHouseId == null || this.WareHouseId === 0) {
				this.showErrorAlert({
					message: this.LocalizePopisPoli('WARE_HOUSE_REQUIRED'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			await this.tableData();
		},

		async exportFun() {
			try {
				if (this.WorkshopId == null) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (this.WareHouseId == null || this.WareHouseId === 0) {
					this.showErrorAlert({
						message: this.LocalizePopisPoli('WARE_HOUSE_REQUIRED'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					return;
				}
				const columnsSeq = getColumnsNames(this.table.columns.filter(x => x.isVisible === true)).join(',');
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.filter.WorkshopId, this.filter.WareHouseId);
				await apiProvider.GetFullStockAgingAnalysisReport(urlParameters, columnsSeq, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
			} finally {
				this.endLoading();
			}
		},

		async onWorkShopChange(workshopId: any) {
			if (workshopId !== undefined) {
				const { data } = await apiProvider.GetWarehouse(workshopId);
				this.dropdownList.WareHouseId = data;
				this.WareHouseId = 0;
			}
		},

		wareHouseUpdate() {
			const result = {} as any;
			this.dropdownList.WareHouseId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},

		GetParameters(WorkshopId: any, WareHouseId:number | null) {
			this.parameters = '';
			this.parameters = this.parameters.concat(`workshopId=${WorkshopId}&WareHouseId=${WareHouseId}`);
			return this.parameters;
		},
	},

	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
